export default __webpack_public_path__ + "static/media/Eligibility_a.aab80512.png";